/** @format */

import Layout from '../Partials/Layout';
import api from '../../shared/utils/auth/Index';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import Loader from '../../shared/components/Loader';

const Print = () => {
	const { search } = useLocation();

	const history = useHistory();

	const [orders, setOrders] = useState(undefined);

	useEffect(() => {
		fetchOrders(1);
	}, [search]);

	const fetchOrders = (print) => {
		let url = `/order?print=${print}`;
		api.get(
			url,
			{},
			(res) => {
				let data = res.data.data;
				setOrders(data);
			},
			(err) => {
				alert('error');
			},
		);
	};
	const filterOrders = (print) => {
		return fetchOrders(print);
	};

	const printPage = () => {
		var printContent = document.getElementById('print-element').innerHTML;
		var originalContent = document.body.innerHTML;
		document.body.innerHTML = printContent;
		window.print();
		document.body.innerHTML = originalContent;
	};

	if (orders === undefined)
		return (
			<Layout>
				<Loader />
			</Layout>
		);

	return (
		<Layout>
			<div className='row border-bottom'>
				<div className='col-12 col-md-3'>
					<div className='form-group'>
						<label>فیلتر</label>
						<select
							onChange={(e) => filterOrders(e.target.value)}
							className='form-control'>
							<option value='1'>چاپ نشده ها</option>
							<option value='0'>همه</option>
						</select>
					</div>
				</div>
				<div className='col-12 col-md-3'>
					<div className='form-group mt-1'>
						<button onClick={printPage} className='btn btn-info mt-4'>
							چاپ
						</button>
					</div>
				</div>
			</div>
			<div className='w-100' id='print-element'>
				<div className='d-flex flex-row flex-wrap justify-content-between'>
					{orders.map((item) => (
						<div
							style={{ height: '300px' }}
							className='w-50 border border-secondary rounded px-2'>
							<div className='d-flex flex-column'>
								<div className='d-flex flex-row justify-content-center p-2'>
									<span
										className='text-dark font-weight-bold'
										style={{ fontSize: '11px' }}>
										گیرنده :
									</span>
									<span
										className='text-navy-blue text-dark mx-2'
										style={{ fontSize: '11px' }}>
										{' '}
										{item.name + ' ' + item.surname}{' '}
									</span>
								</div>
								<div className='d-flex flex-column p-2'>
									<span
										className='text-dark font-weight-bold'
										style={{ fontSize: '11px' }}>
										آدرس :
									</span>
									<p
										className='text-navy-blue text-dark m-0'
										style={{ fontSize: '11px' }}>
										{' '}
										{item.address}{' '}
									</p>
								</div>
								<div className='d-flex d-flex-row justify-content-between'>
									<div className='d-flex flex-column p-2 w-50'>
										<span
											className='text-dark font-weight-bold'
											style={{ fontSize: '11px' }}>
											تلفن :
										</span>
										<span
											className='text-navy-blue text-dark'
											style={{ fontSize: '11px' }}>
											{' '}
											{item.phone}{' '}
										</span>
									</div>
									<div className='d-flex flex-column p-2 align-items-start justify-content-start align-self-start w-50'>
										<span
											className='text-dark font-weight-bold'
											style={{ fontSize: '11px' }}>
											کد پستی :
										</span>
										<span
											className='text-navy-blue text-dark'
											style={{ fontSize: '11px' }}>
											{' '}
											{item.zip_code}{' '}
										</span>
									</div>
								</div>
								<div className='d-flex flex-column'>
									<span
										className='text-dark font-weight-bold'
										style={{ fontSize: '11px' }}>
										لیست کتاب های سفارش داده شده :{' '}
									</span>
									<div className='d-flex flex-row justify-content-between'>
										{item.items?.map((product, index) => (
											<div className='d-flex flex-column align-items-start'>
												<span
													style={{ fontSize: '12px' }}
													className='font-weight-bold my-2'>
													{index + 1}-{product?.product?.name}
												</span>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</Layout>
	);
};

export default Print;
